import React from "react";
import Header from "../../Component/Home/Header";
import CollectionsSection from "../../Component/Home/CollectionsSection";
import ServicesSection from "../../Component/Home/ServicesSection";
import SafetySection from "../../Component/Home/SafetySection";
import ExploreSection from "../../Component/Home/ExploreSection";
import Footer from "../../Component/Home/Footer";
import Slider from "./Landingpage/Sliderss";

const Landingpagess = () => {
  return (
    <>
    
      <Slider />
      <CollectionsSection />
      <ServicesSection />
      <SafetySection />
      <ExploreSection />
    </>
  );
};

export default Landingpagess;